import Axios from "axios";
import { BASE_URL } from "static/constants";

import getToken from "utils/getToken";
import { setupCache } from "axios-cache-interceptor";
import { handleUnauthorizedError } from "utils/auth";

export const axiosCached = setupCache(Axios);

const cacheApi = axiosCached;

//add token to all request
cacheApi.interceptors.request.use(function (config) {
  const token = getToken();

  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }

  return { ...config, baseURL: BASE_URL, withCredentials: true };
});

cacheApi.interceptors.response.use(
  function (response) {
    if (response.data instanceof Blob) {
      return response;
    }
    return response.data;
  },
  function (error) {
    const unauthorizedResult = handleUnauthorizedError(
      error?.response?.status,
      error?.config?.url,
      error?.response?.data
    );
    if (unauthorizedResult) {
      return unauthorizedResult;
    } else if (error?.response && error?.response?.data) {
      if (error.response.data) {
        return Promise.reject(error.response.data);
      } else return Promise.reject(error.response.data);
    } else {
      return Promise.reject({
        message: error?.response?.statusText,
      });
    }
  }
);

export default cacheApi;
